import { Component } from "react";
import { Link } from "react-router-dom";
import { Button, Form, Alert } from "react-bootstrap";
import api from "../utils/api-helper/api";
import FormContainer from "../components/FormContainer";
import { localePath } from "../i18n/config";

class RecoverPassword extends Component {
    state = {
        username: "",
        submitted: false,
        error: "",
        loading: false,
    };

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ username: e.target.value });
    };

    sendPasswordResetEmail = (e: React.FormEvent) => {
        e.preventDefault();
        const { username } = this.state;
        this.setState({ loading: true, error: "" });
        api.post(`/email/reset-password/user/${username}`)
            .then(() => {
                this.setState({ username: "", submitted: true, error: "", loading: false });
            })
            .catch((error) => {
                const errorMsg = error?.response?.data?.message || "Sähköpostiosoitetta ei löydy tai tapahtui virhe.";
                this.setState({ error: errorMsg, loading: false });
            });
    };
    render() {
        const { username, submitted, error, loading } = this.state;
        return (
            <FormContainer>
                <h2 className="my-4 text-center">Vaihda salasana</h2>
                {error && (
                    <Alert variant="danger" className="text-center">
                        {error}
                    </Alert>
                )}
                {submitted ? (
                    <div className="reset-password-form">
                        <p>Jos tili on systeemissämme, lähetimme sinulle sähköpostissa linkin salasanan vaihtamista varten.</p>
                        <Link to={localePath("kirjaudu")} className="tallenna">
                            Kirjaudu
                        </Link>
                    </div>
                ) : (
                    <div className="reset-password-form-wrapper">
                        <p className="my-3">Anna sähköpostiosoitteesi ja lähetämme sinulle ohjeet salasanan vaihtamista varten.</p>
                        <Form onSubmit={this.sendPasswordResetEmail}>
                            <Form.Label htmlFor="email" className="form-label">
                                Sähköpostiosoite
                            </Form.Label>
                            <Form.Group controlId="recover-password-email">
                                <Form.Control required onChange={this.handleChange} value={username} placeholder="Sähköpostiosoite" />
                            </Form.Group>
                            <Button className="password-reset-btn tallenna" type="submit" style={{ width: "100%" }} disabled={loading}>
                                {loading ? "Lähetetään..." : "Lähetä pyyntö salasanan vaihtamiseksi"}
                            </Button>
                        </Form>
                        <Link to={localePath("kirjaudu")} className="muistan-salasanan">
                            Muistan salasanani
                        </Link>
                    </div>
                )}
            </FormContainer>
        );
    }
}
export default RecoverPassword;
